import * as React from 'react'
import { Button, Text } from '@metrisk/react_metrisk-components'

import Field from '@components/Field'

const purchaseFieldsOrder = ['invoiceNo', 'proofOfPurchase', 'proofOfPackaging', 'purchaseItems']

const purchaseFields: any = {
  invoiceNo: {
    type: 'text',
    label: 'Receipt Number',
    validation: (value: any) => value && value.trim().length > 0,
  },
  proofOfPurchase: {
    type: 'upload',
    label: 'Proof of Purchase',
  },
  proofOfPackaging: {
    type: 'upload',
    label: 'Proof of Packaging',
  },
  purchaseItems: {
    type: 'purchaseItems',
    label: null,
  },
}

const PurchaseInformationItem = ({ index, item, upload, formFields, canDelete, onItemUpdate, onDelete }: any) => {
  const fieldsToRender = Object.keys(item.fields)
  const itemFields = purchaseFieldsOrder.filter((field) => fieldsToRender.includes(field))

  const getValue = (field: string) => {
    return item.fields[field].value
  }

  const isValid = (field: string, value: any): boolean => {
    if (value === null) return false

    if (purchaseFields[field]?.validation) {
      return purchaseFields[field]?.validation(value)
    }

    if (Array.isArray(value)) {
      return value.every((item) => item.valid)
    }

    return Boolean(value)
  }

  const handleChange = (field: string, value: any) => {
    onItemUpdate(item.id, field, value, isValid(field, value))
  }

  const handleDelete = () => {
    onDelete(item.id)
  }

  return (
    <div className="purchase-information-item">
      <div className="purchase-information-item__header">
        <Text tag="h5" type={'Delta'}>
          Receipt Item #{index + 1}
        </Text>
        {canDelete && (
          <Button type={'Secondary'} className="purchase-information-item__remove" onClick={handleDelete}>
            Remove Receipt
          </Button>
        )}
      </div>

      {itemFields.map((field: string) => {
        const isReadOnly = Boolean(item?.fields[field]?.readOnly)

        return (
          <Field
            key={`${item.id}-${field}`}
            type={purchaseFields[field].type}
            label={purchaseFields[field].label}
            value={getValue(field)}
            upload={upload}
            formFields={formFields}
            valid={getValue(field) === null ? true : isValid(field, getValue(field))}
            required={isReadOnly ? false : true}
            readOnly={isReadOnly}
            onChange={(value: any) => handleChange(field, value)}
          />
        )
      })}
    </div>
  )
}

export default PurchaseInformationItem
